import * as React from 'react';
import { connect } from 'react-redux';

import ExtendsContextMenuItem from './ExtendsContextMenuItem';

import { withModal } from 'components/modal/ModalHOC';
import ShippingAddressModal from 'components/shipping-address-modal/ShippingAddressModal';

import type { ContextMenuItem } from 'types';

type OwnProps = {
  item: ContextMenuItem,
  onModalClosed?: (a: React.MouseEvent) => void
};

type StateProps = {
  organizationId: string
};

type Props = OwnProps & StateProps;

class ContextMenuItemShippingAddress extends ExtendsContextMenuItem<Props> {
  render() {
    const { item, onModalClosed } = this.props;
    const subcampaign = item.meta ? item.meta.subcampaign : {};

    const DivWithModal = withModal(<span />, {
      modalContent: ShippingAddressModal,
      onModalClosed
    });

    return (
      <DivWithModal
        modalContentProps={{ subcampaign }}
      >
        {this.renderIcon(item)}
        <div className="context-menu-item__text">
          {item.text}
        </div>
      </DivWithModal>
    );
  }
}

const mapStateToProps = ({ organizations }): StateProps => ({
  organizationId: organizations.currentOrganizationId
});

export default connect(mapStateToProps)(ContextMenuItemShippingAddress);
